"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const inversify_1 = require("inversify");
const ServiceIdentifiers_1 = require("../container/ServiceIdentifiers");
const estraverse = __importStar(require("estraverse"));
const string_template_1 = __importDefault(require("string-template"));
const IPrevailingKindOfVariablesAnalyzer_1 = require("../interfaces/analyzers/calls-graph-analyzer/IPrevailingKindOfVariablesAnalyzer");
const NodeGuards_1 = require("../node/NodeGuards");
let CustomNodeFormatter = class CustomNodeFormatter {
    constructor(prevailingKindOfVariablesAnalyzer) {
        this.prevailingKindOfVariables = prevailingKindOfVariablesAnalyzer.getPrevailingKind();
    }
    formatTemplate(template, mapping) {
        return string_template_1.default(template, mapping);
    }
    formatStructure(statements) {
        for (const statement of statements) {
            estraverse.replace(statement, {
                enter: (node) => {
                    if (!NodeGuards_1.NodeGuards.isVariableDeclarationNode(node)) {
                        return;
                    }
                    if (this.prevailingKindOfVariables === 'var') {
                        node.kind = 'var';
                    }
                    return node;
                }
            });
        }
        return statements;
    }
};
CustomNodeFormatter = __decorate([
    inversify_1.injectable(),
    __param(0, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.IPrevailingKindOfVariablesAnalyzer)),
    __metadata("design:paramtypes", [typeof (_a = typeof IPrevailingKindOfVariablesAnalyzer_1.IPrevailingKindOfVariablesAnalyzer !== "undefined" && IPrevailingKindOfVariablesAnalyzer_1.IPrevailingKindOfVariablesAnalyzer) === "function" ? _a : Object])
], CustomNodeFormatter);
exports.CustomNodeFormatter = CustomNodeFormatter;
